import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faChevronDown,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

import { Dropdown, Menu } from "antd";



import "./styles.css";

const logo_mdo = "https://mdocdn.mydigitaloffice.com/images/otelier_ch.svg";
const logo_mdo_small = "https://mdocdn.mydigitaloffice.com/favicons/circle-only-119x120.svg";

const bold = { fontWeight: "bold" };

const Header = ({ nickName, handleLogout, permission }) => {
  const menu = (
    <Menu>
      <Menu.Item style={bold}>
        <Link to="/#" onClick={handleLogout}>
          <FontAwesomeIcon icon={faSignOutAlt} className="logout_icon" />
          Logout
        </Link>
      </Menu.Item>
    </Menu>
  );
  return (
    <div className="header_a">
      <div className="header_row">
        {permission && permission.sm_end_user_access ? (
          <a href={process.env.REACT_APP_SSO_DASHBOARD_URL}>
            <div className="header_aa">
              <img className="img_1" src={logo_mdo} alt="" />
              <img className="img_2" src={logo_mdo_small} alt="" />
            </div>
          </a>
        ) : (
          <Link to="/">
            <div className="header_aa">
              <img className="img_1" src={logo_mdo} alt="" />
              <img className="img_2" src={logo_mdo_small} alt="" />
            </div>
          </Link>
        )}
        <span className="app_name">System Manager</span>
      </div>

      <Dropdown overlay={menu} placement="bottomRight">
        <div className="header_ab">
          <FontAwesomeIcon className="user_profile_icon" icon={faUserCircle} />
          <span className="user_profile_name">{nickName}</span>
          <FontAwesomeIcon
            className="user_profile_arrowDwn"
            icon={faChevronDown}
          />
        </div>
      </Dropdown>
    </div>
  );
};

export default Header;
